import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=2fc31798&scoped=true"
import script from "./WizardStep.vue?vue&type=script&lang=js"
export * from "./WizardStep.vue?vue&type=script&lang=js"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=2fc31798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc31798",
  null
  
)

export default component.exports